import { render } from "./MapRenderer.vue?vue&type=template&id=525132da&scoped=true&ts=true"
import script from "./MapRenderer.vue?vue&type=script&lang=ts"
export * from "./MapRenderer.vue?vue&type=script&lang=ts"

import "./MapRenderer.vue?vue&type=style&index=0&id=525132da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525132da"]])

export default __exports__